/**
 * 对象工具类
 * @author frankylli
 */
import isArray from 'lodash-es/isArray'
import isPlainObject from 'lodash-es/isPlainObject'
import cloneDeep from 'lodash-es/cloneDeep'

export const deepFreeze = function deepFreeze(o) {
  Object.freeze(o)

  Object.getOwnPropertyNames(o).forEach(function(prop) {
    if (o.hasOwnProperty(prop) &&
    o[prop] !== null &&
    (typeof o[prop] === 'object' || typeof o[prop] === 'function') &&
    !Object.isFrozen(o[prop])) {
      deepFreeze(o[prop])
    }
  })

  return o
}

export const toMap = (arr) => {
  return arr.reduce((result, item) => {
    result[item.id] = item.name
    return result
  }, {})
}

/**
 * 文件对象转为前端需要的格式
 * @export
 * @param {Object|Array} fileList
 * @param {string} [urlKey='photoUrl']
 * @returns
 */
export function fileToFrontend(fileList, urlKey = 'photoUrl') {
  const fl = cloneDeep(fileList)
  if (isArray(fl)) {
    for (const file of fl) {
      file.url = file[urlKey]
    }
  } else if (isPlainObject(fl)) {
    fl.url = fl[urlKey]
  }

  return fl
}

export function setForeignId(data, key, defaultValue) {
  if (!data[key]) {
    data[key] = defaultValue
  } else {
    data[key] = data[key].split(' -@- ')[0]
  }
}
/**
 * @param {Object} data
 * @param {String} key - 对象需要设置的 key
 * @param {String} id - id 键名
 * @param {String} name - 名字键名
 */
export function getForeignId(data, key, id, name) {
  const obj = data[key]
  data[key] = obj ? `${obj[id]} -@- ${obj[name]}` : ''
}

/**
 * 清空object 中空字段，null,undefined,空字符,空数组
 * @param {Object} obj
 * @return {Object}
 */
export function clearEmptyKey(obj) {
  if (!isPlainObject(obj) || obj === null) return obj
  let isEmptyObject = true
  const result = Object.keys(obj).reduce((tmp, key) => {
    const current = obj[key]
    if (current === null || current === undefined || current === '') {
      return tmp
    }
    const isArr = Array.isArray(current)
    if (isArr && current.length === 0) {
      return tmp
    } else if (isPlainObject(current)) {
      const cur = clearEmptyKey(current)
      if (cur) {
        tmp[key] = cur
      } else {
        return tmp
      }
    } else {
      tmp[key] = current
    }
    isEmptyObject = false
    return tmp
  }, {})

  return isEmptyObject ? null : result
}

/**
 * 清空对象中每个健的值
 * @param {*} obj 修改对象
 */
export function clearKey(obj) {
  const newObj = cloneDeep(obj)
  Object.entries(newObj).forEach(([key, val]) => {
    switch (typeof val) {
      case 'string':
        newObj[key] = ''
        break
      case 'number':
        newObj[key] = 0
        break
      case 'boolean':
        newObj[key] = false
        break
      case 'object':
        if (val !== null) {
          newObj[key] = Array.isArray(val) ? [] : clearKey(newObj[key])
        }
        break

      default:
        break
    }
  })

  return newObj
}

export function safeJsonParse(jsonText, defaultValue = '') {
  try {
    const res = JSON.parse(jsonText)
    return res
  } catch (error) {
    return defaultValue
  }
}
